let swiper2;
$(function(){
  const $optionsWrap = $(".product__info-wrapper");
  $(window).resize(function(){
    const width = window.innerWidth;

    if(width <= 990){
      $(".product_img_wrap").after($optionsWrap);
    } else {
      $(".product__media-wrapper").after($optionsWrap);
    }
  })
  if(window.innerWidth <= 990){
      $(".product_img_wrap").after($optionsWrap);
  }

  $(".mobile_buy a").click(function(){
    $(".shopify-payment-button__button--shoppay").trigger("click");
  })
  // $(".product_detail_dropdown").click(function(){
  //   $(".product_detail").toggleClass("hide");
  // })

  $(".size_chart_btn").click(function(){
    const imgSrc = $(this).data("img-url");
    const imgSrcM = $(this).data("img-url-m");

    let c = "";
    if(imgSrcM){
      c += "isM"
    }

    const html= `
    <div class="popup-size-chart ${c}">
      <div>
        <div>
        <img src=${imgSrc}/ alt='' class="pc">
        <img src=${imgSrcM}/ alt='' class="mo">
        
        <button type="button" class="popup-size-chart-close-btn">
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path d="M16.1586 1.84201L1.84277 16.1578" stroke="#3A3A3A" stroke-width="1.4" stroke-linecap="square" stroke-linejoin="round"/>
            <path d="M1.84192 1.84201L16.1577 16.1578" stroke="#3A3A3A" stroke-width="1.4" stroke-linecap="square" stroke-linejoin="round"/>
          </svg>
        </button>
        </div>
      </div>
    </div>
    <div class="popup-size-chart-dimmed"><i></i></div>
    `;

    $("body").append(html);
  })

  $(document).on("click", function(e){
    if($(e.target).hasClass("popup-size-chart-close-btn") || $(e.target).hasClass("popup-size-chart-dimmed")){
      $(".popup-size-chart").remove();
      $(".popup-size-chart-dimmed").remove();
    }
  })

  const swiper = new Swiper(".product_pager_wrap .swiper", {
    spaceBetween: 12,
    slidesPerView: "auto",
    freeMode: true,
    // centeredSlides: true,
    // centeredSlidesBounds: true,
    watchOverflow: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    direction: 'horizontal',
    breakpoints: {
        990: {
          // slidesPerView: 2,
          direction: 'vertical',
          spaceBetween: 7,
        },
    }
  });
  
  swiper2 = new Swiper(".product_thumb_wrap .swiper", {
    spaceBetween: 0,
    navigation: {
      nextEl: ".thumb-btn-next",
      prevEl: ".thumb-btn-prev",
    },
    thumbs: {
      swiper: swiper,
    },
  });
  let isVideo = null;
  $(".btn_video").on("click", function(){  
    $(this).hide(0);
    isVideo = $(this).siblings("video")[0];
    isVideo.play();
  })

  swiper2.on('slideChange', function () {
    $(".product_img_wrap").removeClass("fade");
    
    if(isVideo){
      isVideo.pause();      
    }
  });

  // 
  let currentThumb = 0;
  const $ctc = $("#cTC");
  
  if($ctc.length == 1){
    ctc = $ctc.val().split("|");
    $(".product-form__input--swatch input[type='radio']").each(function(i,e){      
      
      if($(e).prop("checked")){
        currentThumb = ctc[i] - 1;        
      };
    })
    if(currentThumb != 0){
      swiper2.slideTo(currentThumb, 0);      
    } else {
      $(".product_img_wrap").removeClass("fade");
    }
  } else {
    $(".product_img_wrap").removeClass("fade");
  }  

  // 드랍다운
  $("#MainProduct .product_dropdown_item button").click(function(){
    $(this).toggleClass("show");
    $(this).siblings(".dropdown_cont").slideToggle(300);
  })

  // PC 리뷰
  const $btnDesc = $(".product_tab .btn_desc");
  const $btnRev = $(".product_tab .btn_reivews");

  $(".product_tab a").click(function(){
    $(this).addClass("active");
    $(this).siblings().removeClass("active");
  })

  // 리뷰 개수
  if(parseInt($(".jdgm-prev-badge__text").text())){
    $badge = $("<span></span>");
    $badge.text(parseInt($(".jdgm-prev-badge__text").text()));
    $(".btn_reivews").append($badge);    
  }
})